import { apiSlice } from "../../apis/ApiSlice";
const apiUrl = process.env.REACT_APP_API_URL;
const AUTH_URL = `${apiUrl}/api/auth`;

export const AccountapiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (user) => ({
        url: `${AUTH_URL}/register`,
        method: "POST",
        body: user,
      }),
    }),
    checkUser: builder.mutation({
      query: (user) => ({
        url: `${AUTH_URL}/user-existence`,
        method: "POST",
        body: user,
      }),
    }),
    login: builder.mutation({
      query: (user) => ({
        url: `${AUTH_URL}/login`,
        method: "POST",
        body: user,
      }),
    }),

    forgotPassword: builder.mutation({
      query: (email) => ({
        url: `${AUTH_URL}/forgotPassword`,
        method: "POST",
        body: { email },
      }),
    }),

    resendOtp: builder.mutation({
      query: (email) => ({
        url: `${AUTH_URL}/resendOtp`,
        method: "POST",
        body: { email },
      }),
    }),

    verifyOtp: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/verifyOtp`,
        method: "POST",
        body: data,
      }),
    }),

    resetPassword: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/resetPassword`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useRegisterMutation,
  useCheckUserMutation,
  useLoginMutation,
  useForgotPasswordMutation,
  useResendOtpMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
} = AccountapiSlice;
